import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { loadingState, selectLive, selectSize, selectTab } from "atoms";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { useQuery } from "react-query";
import { tradeListApi } from "fetchers/currentValueApi";
import MixedCharts from "../components/Chart/MixedChart/MixedChart";
import MultiAxis from "../components/Chart/MultiAxis/MultiAxis";
import Table from "../components/Table";

const ChartData = () => {
  const [currentTab, setCurrentTab] = useRecoilState(selectTab);
  const currentMenu = useRecoilValue(selectLive);
  const currentSize = useRecoilValue(selectSize);
  const setLoading = useSetRecoilState(loadingState);
  const [multiAxisData, setMultiAxisData] = useState([]);
  const [mixedChartData, setMixedChartData] = useState([]);

  const { isLoading: tradeInfoLoading, data: tradeInfoData } = useQuery(
    ["trade_data", currentMenu, currentSize, currentTab],
    () => {
      return currentSize && tradeListApi(currentMenu, currentSize);
    },
    {
      staleTime: 60 * 5000,
    }
  );

  useEffect(() => {
    tradeInfoLoading ? setLoading(true) : setLoading(false);
  }, [tradeInfoLoading, setLoading]);

  useEffect(() => {
    if (currentMenu === "m") {
      const length = tradeInfoData?.data?.length;
      const mPriceArr = [];
      const mTradeArr = [];
      tradeInfoData?.data?.forEach((data, idx) => {
        const { date, m, m_cnt } = data;

        if (currentTab === "recent") {
          if (idx > length - 37) {
            m !== "" &&
              mPriceArr.push({
                x: date,
                y: m && (m / 10000).toFixed(1),
              });
            m_cnt !== "0" &&
              mTradeArr.push({
                x: date,
                y: m_cnt,
              });
          }
        } else if (currentTab === "all") {
          m !== "" &&
            mPriceArr.push({
              x: date,
              y: m && (m / 10000).toFixed(1),
            });
          m_cnt !== "0" &&
            mTradeArr.push({
              x: date,
              y: m_cnt,
            });
        }
      });
      setMultiAxisData({
        ...multiAxisData,
        mPriceArr,
        mTradeArr,
      });
    } else if (currentMenu === "jw") {
      const length = tradeInfoData?.data?.length;
      const jPriceArr = [];
      const jTradeArr = [];
      const wTradeArr = [];
      tradeInfoData?.data?.forEach((data, idx) => {
        const { date, j, j_cnt, w_cnt } = data;
        if (currentTab === "recent") {
          if (idx + 1 > length - 74) {
            if (idx % 2 === 0) {
              j &&
                jPriceArr.push({
                  x: date,
                  y: j && (j / 10000).toFixed(1),
                });
              j_cnt &&
                jTradeArr.push({
                  x: date,
                  y: j_cnt,
                });
            } else {
              w_cnt &&
                wTradeArr.push({
                  x: date,
                  y: w_cnt,
                });
            }
          }
        } else if (currentTab === "all") {
          if (idx % 2 === 0) {
            j !== "" &&
              jPriceArr.push({
                x: date,
                y: j && (j / 10000).toFixed(1),
              });
            j_cnt !== "0" &&
              jTradeArr.push({
                x: date,
                y: j_cnt,
              });
          } else {
            w_cnt !== "0" &&
              wTradeArr.push({
                x: date,
                y: w_cnt,
              });
          }
        }
      });
      setMixedChartData({
        ...mixedChartData,
        jPriceArr,
        jTradeArr,
        wTradeArr,
      });
    }
  }, [tradeInfoData]);

  const handleClick = (name) => {
    setCurrentTab(name);
  };

  return (
    <ChartDataContainer className="d-flex flex-column">
      <ChartDataChartWrapper className="pt-4 mb-4">
        {tradeInfoLoading ? (
          <div style={{ height: "100vmin" }}></div>
        ) : currentMenu === "m" ? (
          <MultiAxis data={multiAxisData} />
        ) : (
          <MixedCharts data={mixedChartData} />
        )}
      </ChartDataChartWrapper>
      <ChartDataTableWrapper className="px-4">
        {tradeInfoLoading ? null : <Table />}
      </ChartDataTableWrapper>
    </ChartDataContainer>
  );
};

const ChartDataContainer = styled.section``;
const ChartDataChartWrapper = styled.div`
  height: 250px;
`;

const ChartDataTableWrapper = styled.div``;

export default ChartData;
